/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleTransfer = {
    properties: {
        id: {
    type: 'number',
},
        scheduleId: {
    type: 'number',
},
        fromAssigneeId: {
    type: 'number',
},
        fromAssigneeName: {
    type: 'string',
},
        toAssigneeId: {
    type: 'number',
},
        toAssigneeName: {
    type: 'string',
},
        status: {
    type: 'ScheduleTransferStatus',
},
        createdAt: {
    type: 'string',
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};